export let ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType[ErrorType["Unknown"] = 0] = "Unknown";
  ErrorType[ErrorType["Login"] = 1] = "Login";
  ErrorType[ErrorType["Acl"] = 2] = "Acl";
  ErrorType[ErrorType["NotFound"] = 3] = "NotFound";
  ErrorType[ErrorType["ParameterError"] = 4] = "ParameterError";
  ErrorType[ErrorType["LogicalError"] = 5] = "LogicalError";
  return ErrorType;
}({});
export let ErrorCodeMapKey = /*#__PURE__*/function (ErrorCodeMapKey) {
  ErrorCodeMapKey[ErrorCodeMapKey["Login_InvalidToken"] = 100001] = "Login_InvalidToken";
  ErrorCodeMapKey[ErrorCodeMapKey["Login_InvalidWxCode"] = 100002] = "Login_InvalidWxCode";
  ErrorCodeMapKey[ErrorCodeMapKey["Login_BindConflict"] = 100011] = "Login_BindConflict";
  ErrorCodeMapKey[ErrorCodeMapKey["Login_BindError"] = 100012] = "Login_BindError";
  ErrorCodeMapKey[ErrorCodeMapKey["Login_NeedMerge"] = 100013] = "Login_NeedMerge";
  ErrorCodeMapKey[ErrorCodeMapKey["Login_CaptchaError"] = 100021] = "Login_CaptchaError";
  ErrorCodeMapKey[ErrorCodeMapKey["Login_LackCaptcha"] = 100022] = "Login_LackCaptcha";
  ErrorCodeMapKey[ErrorCodeMapKey["Acl_NeedNodeReadAcl"] = 200001] = "Acl_NeedNodeReadAcl";
  ErrorCodeMapKey[ErrorCodeMapKey["Acl_NeedViewReadAcl"] = 200011] = "Acl_NeedViewReadAcl";
  ErrorCodeMapKey[ErrorCodeMapKey["NotFound_Organization"] = 300001] = "NotFound_Organization";
  ErrorCodeMapKey[ErrorCodeMapKey["NotFound_View"] = 300002] = "NotFound_View";
  ErrorCodeMapKey[ErrorCodeMapKey["NotFound_Automation"] = 300003] = "NotFound_Automation";
  ErrorCodeMapKey[ErrorCodeMapKey["NotOpen_Automation"] = 300004] = "NotOpen_Automation";
  ErrorCodeMapKey[ErrorCodeMapKey["Parameter_Error"] = 400000] = "Parameter_Error";
  ErrorCodeMapKey[ErrorCodeMapKey["Logical_UnInitTableDoc"] = 500001] = "Logical_UnInitTableDoc";
  ErrorCodeMapKey[ErrorCodeMapKey["Logical_ConditionMismatch"] = 500002] = "Logical_ConditionMismatch";
  return ErrorCodeMapKey;
}({});
export const ErrorCodeMap = {
  // Login
  Login_InvalidToken: {
    errorCode: ErrorCodeMapKey.Login_InvalidToken,
    message: {
      'en-us': 'Login error，invalid token',
      'zh-cn': '认证失败, token失效'
    },
    type: ErrorType.Login
  },
  Login_InvalidWxCode: {
    errorCode: ErrorCodeMapKey.Login_InvalidWxCode,
    message: {
      'en-us': 'Login error，invalid wx code',
      'zh-cn': '认证失败, 无效的微信code'
    },
    type: ErrorType.Login
  },
  Login_BindConflict: {
    errorCode: ErrorCodeMapKey.Login_BindConflict,
    message: {
      'en-us': 'Bind error，login method conflict',
      'zh-cn': '绑定失败, 登录方式已注册，且与当前账号有冲突，无法合并账号'
    },
    type: ErrorType.Login
  },
  // Acl
  Acl_NeedNodeReadAcl: {
    errorCode: ErrorCodeMapKey.Acl_NeedNodeReadAcl,
    message: {
      'en-us': "Can't read node",
      'zh-cn': '没有权限读取节点'
    },
    type: ErrorType.Acl
  },
  Acl_NeedViewReadAcl: {
    errorCode: ErrorCodeMapKey.Acl_NeedViewReadAcl,
    message: {
      'en-us': "Can't read node",
      'zh-cn': '没有权限读取节点'
    },
    type: ErrorType.Acl
  },
  // NotFound
  NotFound_Organization: {
    errorCode: ErrorCodeMapKey.NotFound_Organization,
    message: {
      'en-us': 'Organization not found',
      'zh-cn': '找不到空间'
    },
    type: ErrorType.NotFound
  },
  NotFound_View: {
    errorCode: ErrorCodeMapKey.NotFound_View,
    message: {
      'en-us': 'View not found',
      'zh-cn': '找不到视图'
    },
    type: ErrorType.NotFound
  },
  // LogicalError
  Logical_UnInitTableDoc: {
    errorCode: ErrorCodeMapKey.Logical_UnInitTableDoc,
    message: {
      'en-us': 'Table is uninitialized',
      'zh-cn': '表格没有初始化'
    },
    type: ErrorType.LogicalError
  }
};